module.exports = __webpack_public_path__ + "img/divider.b6e5a2fe.jpg";